module.exports = __webpack_public_path__ + "img/危废处置客服弹窗.05aa40f0.png";